import React from 'react';

import DisciplinesList from './disciplinesListComponent';
import SingleDiscipline from './singleDisciplineComponent';

import NoResults from './../no_results/noResultsComponent';

class Disciplines extends React.Component {
  constructor() {
    super();

    this.createDiscipline = this.createDiscipline.bind(this);
  }

  createDiscipline(item, i) {
    return <SingleDiscipline data={item} key={i} dispatchReducer={this.props.dispatchReducer} />;
  }

  render() {
    let firstColumn = this.props.data.firstColumn || [],
        secondColumn = this.props.data.secondColumn || [];

    return <div>
      {
        firstColumn.length === 0 && secondColumn.length === 0 ?
        <div id="degrees-wrap" className="degrees-wrap clearfix">
          <NoResults msg={'No results were found.'} />
        </div> :

        <div id="degrees-wrap" className="degrees-wrap clearfix">
          <DisciplinesList data={firstColumn} createDiscipline={this.createDiscipline} />
          <DisciplinesList data={secondColumn} createDiscipline={this.createDiscipline} />
        </div>
      }
    </div>;
  }
}

Disciplines.propTypes = {
  data:            React.PropTypes.object.isRequired,
  dispatchReducer: React.PropTypes.func.isRequired
};

export default Disciplines;
